import { FormsModule, ReactiveFormsModule } from '@angular/forms';

export const COMMON_MODULE_IMPORT = [
  FormsModule,
  ReactiveFormsModule
];

